import { IsNumberString, ValidateIf } from 'class-validator';
import { TenantDetailsIsMpnIdServerValidated } from '../validators/TenantDetailsIsMpnIdServerValidated';
import { TenantDetailsIsMpnIdValid } from '../validators/TenantDetailsIsMpnIdValid';
import { FormDataBase } from '@/common/form';

export class TenantDetailsFormDataMicrosoftPartner extends FormDataBase {

  @ValidateIf((form: TenantDetailsFormDataMicrosoftPartner) => form.mpnId !== '')
  @TenantDetailsIsMpnIdValid('isMpnValid', 'isMpnValidating', 'isMpnValidated', { message: 'MPN ID must be empty or contain a validated value.' })
  @TenantDetailsIsMpnIdServerValidated('isMpnValid', 'isMpnValidated', { message: 'The MPN ID does not exist. Please try another MPN ID.' })
  @IsNumberString({}, { message: 'MPN ID can only contain numbers.' })
  mpnId: string | undefined = '';

  mpnName: string | undefined = '';
  isMpnValid: boolean = false;
  isMpnValidating: boolean = false;
  isMpnValidated: boolean = false;
  loading: boolean = false;
}
